import styled from 'styled-components';

import { colorsPalettes, setFontVariant } from '@similarweb/styles';

export const StyledTag = styled.div<{ maxWidth?: string }>`
  padding: 2px 8px;
  background: ${colorsPalettes.carbon[0]};
  border: 1px solid ${colorsPalettes.carbon[50]};
  ${setFontVariant('sectionTitle', colorsPalettes.carbon[400])};
  font-size: 10px;
  font-weight: 500;
  border-radius: 4px;
  max-width: ${({ maxWidth }) => maxWidth};
  & .text-overflow-tooltip {
    max-width: 100%;
  }
`;
